import api from './api';

class ActiveAgentAiService {
  // Current plan status + this month's AI-concierge lead usage
  async getStatus() {
    try {
      const response = await api.get('/active-agent-ai/status');
      return response.data;
    } catch (error) {
      console.error('Error getting ActiveAgent AI status:', error);
      throw error;
    }
  }

  // Subscribe to a tier ('basic' or 'pro')
  async subscribe(paymentMethodId, tier) {
    try {
      const response = await api.post('/active-agent-ai/subscribe', {
        payment_method_id: paymentMethodId,
        tier
      });
      return response.data;
    } catch (error) {
      console.error('Error subscribing to ActiveAgent AI:', error);
      throw error;
    }
  }

  // Switch between Basic/Pro on an existing subscription
  async changeTier(tier) {
    try {
      const response = await api.post('/active-agent-ai/change-tier', { tier });
      return response.data;
    } catch (error) {
      console.error('Error changing ActiveAgent AI tier:', error);
      throw error;
    }
  }

  // Cancel subscription
  async cancelSubscription() {
    try {
      const response = await api.post('/active-agent-ai/cancel');
      return response.data;
    } catch (error) {
      console.error('Error canceling ActiveAgent AI subscription:', error);
      throw error;
    }
  }
}

export default new ActiveAgentAiService();
